import React, { useCallback, useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { useHistory, useParams } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { showToast } from "../ToastManager";
import { Dropdown } from 'primereact/dropdown';

import PrestadorService from "../../service/PrestadorService";
import PrestadorTipoAgendamentoService from "../../service/PrestadorTipoAgendamentoService";
import AgendamentoTipoService from '../../service/AgendamentoTipoService';

const prestadorService = new PrestadorService(); // Create an instance of LojaService
const prestadorTipoAgendamentoService = new PrestadorTipoAgendamentoService(); // Create an instance of LojaService
const agendamentoTipoService = new AgendamentoTipoService(); // Create an instance of LojaService

const CadastrarPrestadorTipoAgendamento = () => {
    const iss = localStorage.getItem('iss');
    const history = useHistory();

    let prestadorTipoAgendamentoNovo = {
        id: null,
        prestador_id: '',
        prestador: null,
        tipo_agendamento_id: '',
        tipoAgendamento: null,
        percentual_servico: '',
        ativo: true,
    };

    const [prestadorTipoAgendamento, setPrestadorTipoAgendamento] = useState(prestadorTipoAgendamentoNovo);
    const [prestador, setPrestador] = useState([]);
    const [tipoAgendamento, TipoAgendamento] = useState([]);
    const [selectedPrestador, setSelectedPrestador] = useState(null);
    const [selectedTipoAgendamento, setSelectedTipoAgendamento] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);

    const { id } = useParams();

    const initPrestador = useCallback(async () => {
        setLoading(true);

        try {
            const data = await prestadorService.listAllPrestadores(iss);
            const updatedItems = data.data.rows.map(({ user, tipoPrestador, user_id, tipo_prestador_id, cpf, registro_profissional, email, telefone, data_nascimento, ativo, excluido, createdAt, updatedAt, ...rest }) => rest);
            setPrestador(updatedItems);
        } catch (error) {
            console.error("Erro ao carregar prestador:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar prestador' });
        } finally {
            setLoading(false);
        }
    }, [iss]);

    const initTipoAgendamento = useCallback(async () => {
        setLoading(true);

        try {
            const data = await agendamentoTipoService.listAllTipoAgendamento(iss);
            const updatedItems = data.data.rows.map(({ descricao, duracao_padrao, valor, company_id, ativo, excluido, prestador_id, createdAt, updatedAt, ...rest }) => rest);
            TipoAgendamento(updatedItems);
        } catch (error) {
            console.error("Erro ao carregar servico:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar servico' });
        } finally {
            setLoading(false);
        }
    }, [iss]);

    useEffect(() => {
        initPrestador();
        initTipoAgendamento();
    }, [initPrestador, initTipoAgendamento]);

    useEffect(() => {
        const loadAgendaData = async () => {
            if (id && !dataLoaded) {
                try {
                    setLoading(true);
                    const data = await prestadorTipoAgendamentoService.getPrestadorTipoAgendamento(iss, id);
                    const prestadorTipoAgendamentoNovo = data.data.rows[0];

                    setSelectedPrestador(prestadorTipoAgendamentoNovo.prestador)
                    setSelectedTipoAgendamento(prestadorTipoAgendamentoNovo.tipoAgendamento)
                    setTimeout(() => {
                        setPrestadorTipoAgendamento(prestadorTipoAgendamentoNovo);
                    }, 200);
                    setDataLoaded(true);
                } catch (error) {
                    console.error("Erro ao carregar dados:", error);
                } finally {
                    setLoading(false);
                }
            }
        }
        loadAgendaData();
    }, [dataLoaded, id, iss]);


    const onInputChange = (e, name, list = false, checkbox = false,) => {
        let val = (e.target && e.target.value) || '';
        if (checkbox) {
            val = e.checked;
        }

        if (name === 'prestador_id') {
            setSelectedPrestador(e.value)
            val = e.value.id;
        }

        if (name === 'tipo_agendamento_id') {
            setSelectedTipoAgendamento(e.value)
            val = e.value.id;
        }

        let _prestadorTipoAgendamento = { ...prestadorTipoAgendamento };
        // Verifica se o nome tem um ponto
        if (name.includes('.')) {
            const [parent, child] = name.split('.'); // Divide o nome em pai e filho
            if (!_prestadorTipoAgendamento[parent]) {
                _prestadorTipoAgendamento[parent] = {}; // Cria o objeto pai se não existir
            }
            _prestadorTipoAgendamento[parent][child] = val; // Define o valor do atributo filho
        } else {
            if (list) {
                _prestadorTipoAgendamento[name] = val;
            } else {
                _prestadorTipoAgendamento[name] = val; // Define o valor diretamente se não houver aninhamento
            }

        }

        setPrestadorTipoAgendamento(_prestadorTipoAgendamento);

    }

    const cadastrar = () => {
        setSubmitted(true);
        if (prestadorTipoAgendamento.prestador_id && prestadorTipoAgendamento.tipo_agendamento_id && prestadorTipoAgendamento.percentual_servico) {
            setLoading(true)

            if (prestadorTipoAgendamento.id != null) {
                prestadorTipoAgendamentoService.putPrestadorTipoAgendamento(iss, prestadorTipoAgendamento, prestadorTipoAgendamento.id).then(data => {
                    showToast({ severity: 'success', summary: 'Colaborador editada', detail: 'Colaborador editada com sucesso' });
                    history.push('/prestador/tipo/agendamento/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao editar', detail: 'Erro ao editar prestadorTipoAgendamento' });
                }).finally(() => { setLoading(false) });
            } else {
                prestadorTipoAgendamentoService.postPrestadorTipoAgendamento(iss, prestadorTipoAgendamento).then(data => {
                    showToast({ severity: 'success', summary: 'Tipo cadastrada', detail: 'Tipo cadastrado com sucesso' });
                    history.push('/prestador/tipo/agendamento/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: 'Erro ao cadastrar prestadorTipoAgendamento' });
                }).finally(() => { setLoading(false) });
            }


        } else {
            showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: 'Preencha todos os campos' });
        }

    }

    return (
        <div className="grid">
            <h4>Informações do serviço prestador</h4>
            <div className="col-12">
                <div className="card">

                    <div style={{ marginTop: 10 }} className="p-fluid formgrid grid">
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <Dropdown optionLabel="nome" value={selectedPrestador}
                                    className={classNames({ 'p-invalid': submitted && !prestadorTipoAgendamento.prestador_id })}
                                    options={prestador}
                                    onChange={(e) => {
                                        onInputChange(e, 'prestador_id')
                                    }} />
                                <label htmlFor="prestador_id">Prestador</label>
                            </span>
                            {submitted && !selectedPrestador &&
                                <small className="p-invalid">Prestador é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <Dropdown optionLabel="nome" value={selectedTipoAgendamento}
                                    className={classNames({ 'p-invalid': submitted && !prestadorTipoAgendamento.tipo_agendamento_id })}
                                    options={tipoAgendamento}
                                    onChange={(e) => {
                                        onInputChange(e, 'tipo_agendamento_id')
                                    }} />
                                <label htmlFor="tipo_agendamento_id">Tipo Atendimento</label>
                            </span>
                            {submitted && !selectedTipoAgendamento &&
                                <small className="p-invalid">Tipo Atendimento é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-4">
                            <span className="p-float-label">
                                <InputText value={prestadorTipoAgendamento.percentual_servico}
                                    onChange={(e) => onInputChange(e, 'percentual_servico')}
                                    className={classNames({ 'p-invalid': submitted && !prestadorTipoAgendamento.percentual_servico })}
                                    required
                                    id="percentual_servico" type="text" />
                                <label htmlFor="percentual_servico">Percentual do prestador (%)</label>
                            </span>
                            {submitted && !prestadorTipoAgendamento.percentual_servico &&
                                <small className="p-invalid">Percentual do prestador é obrigatório.</small>}
                        </div>

                        <Button label={id != null ? 'Atualizar' : 'Cadastrar'} loading={loading} style={{ width: '100%', marginTop: 10 }}
                            onClick={cadastrar} className="mr-2 mb-2"></Button>

                        <div onClick={history.goBack} style={{ width: '100%', marginTop: 10, textAlign: 'center', cursor: 'pointer' }}>
                            <i className="pi pi-arrow-left"></i><span style={{ marginLeft: 10, }}>Voltar</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(CadastrarPrestadorTipoAgendamento, comparisonFn);
